import { Icon } from '@kinesis/bungle';

const GHGProtocolIcon = (props: GHGProtocolIconProps) => (
  <Icon type='custom' magnitude={props.magnitude ?? 'medium'}>
    <svg
      width='68'
      height='68'
      viewBox='0 0 68 68'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1'
        y='1'
        width='66'
        height='66'
        rx='3'
        fill='white'
        stroke='#E9E9E9'
        stroke-width='2'
      />
      <path
        // eslint-disable-next-line max-len
        d='M12.7872 12.8035C8.18239 17.3881 6.27582 22.5596 6.27582 22.5596C34.7229 18.0886 42.3556 25.6973 42.3556 25.6973C40.127 22.1832 37.0635 18.7648 33.9949 15.7982C28.2396 10.231 22.5186 6.27679 22.5186 6.27679C18.4713 7.95344 15.2729 10.3293 12.7872 12.8035Z'
        fill='url(#paint0_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M33.9058 4.00028C27.4632 4.00028 22.5186 6.28053 22.5186 6.28053C45.7856 23.2856 45.82 34.0791 45.82 34.0791C46.7211 30.0125 46.9667 25.4241 46.8891 21.1534C46.744 13.1338 45.4865 6.28303 45.4865 6.28303C41.4443 4.60128 37.5064 4.01304 34.0025 4.00028H33.9058Z'
        fill='url(#paint1_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M42.3556 42.459C45.8607 40.2235 49.273 37.1522 52.2295 34.0771C57.7851 28.3058 61.7268 22.5689 61.7268 22.5689C60.0544 18.5138 57.6858 15.306 55.2154 12.814C50.645 8.19752 45.4853 6.2873 45.4853 6.2873C49.9462 34.8056 42.3556 42.459 42.3556 42.459Z'
        fill='url(#paint2_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M33.9949 45.9147C38.0524 46.8181 42.6305 47.0643 46.8891 46.9865C54.887 46.841 61.7216 45.5817 61.7216 45.5817C63.3991 41.5279 63.9871 37.5787 63.9999 34.0671C64.0202 27.5622 61.7216 22.5527 61.7216 22.5527C44.7661 45.8777 34.0013 45.9032 34.0013 45.9032'
        fill='url(#paint3_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M25.6445 42.4433C27.8756 45.956 30.9378 49.3757 34.0039 52.3424C39.7643 57.9082 45.4751 61.8574 45.4751 61.8574C49.5212 60.1808 52.7298 57.8087 55.2154 55.3358C59.8189 50.7499 61.7242 45.5784 61.7242 45.5784C33.2784 50.0495 25.6445 42.4433 25.6445 42.4433Z'
        fill='url(#paint4_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M21.1046 46.9882C21.2497 55.0065 22.5262 61.8509 22.5262 61.8509C25.5083 63.0925 28.4216 63.7407 31.1503 64.001H36.8739C41.9012 63.5059 45.4751 61.8573 45.4751 61.8573C22.2055 44.8484 22.1737 34.0536 22.1737 34.0536C21.2738 38.1189 21.0269 42.7086 21.1046 46.9806'
        fill='url(#paint5_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M15.7807 34.0635C10.2277 39.836 6.27838 45.5805 6.27838 45.5805C7.95204 49.6356 10.3257 52.8358 12.7936 55.3278C17.3665 59.9431 22.5262 61.8545 22.5262 61.8545C18.0665 33.3349 25.6534 25.6816 25.6534 25.6816C22.1482 27.9184 18.7373 30.9871 15.7807 34.0635Z'
        fill='url(#paint6_linear_5608_3930)'
      />
      <path
        // eslint-disable-next-line max-len
        d='M21.1097 21.1481C13.1117 21.2936 6.27582 22.5645 6.27582 22.5645C4.59834 26.6183 4.01288 30.5547 4.00015 34.0675C3.97852 40.5724 6.27837 45.582 6.27837 45.582C23.2402 22.2545 34.0038 22.2212 34.0038 22.2212C30.4058 21.4199 26.3954 21.1353 22.5593 21.1353C22.0731 21.1353 21.5895 21.1405 21.1097 21.1481Z'
        fill='url(#paint7_linear_5608_3930)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5608_3930'
          x1='22.2919'
          y1='42.5752'
          x2='3.61521'
          y2='20.3738'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5608_3930'
          x1='19.7264'
          y1='31.7884'
          x2='22.2641'
          y2='2.85643'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5608_3930'
          x1='25.5197'
          y1='22.3453'
          x2='47.7591'
          y2='3.73156'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_5608_3930'
          x1='36.2786'
          y1='19.7605'
          x2='65.1401'
          y2='22.2791'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_5608_3930'
          x1='45.7099'
          y1='25.5619'
          x2='64.3858'
          y2='47.7623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_5608_3930'
          x1='48.2666'
          y1='36.3512'
          x2='45.7291'
          y2='65.2819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_5608_3930'
          x1='42.4906'
          y1='45.7956'
          x2='20.2501'
          y2='64.4102'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_5608_3930'
          x1='31.7211'
          y1='48.3761'
          x2='2.85932'
          y2='45.8574'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='#00ACA1' />
        </linearGradient>
      </defs>
    </svg>
  </Icon>
);

type GHGProtocolIconProps = {
  magnitude?: 'small' | 'medium';
};

export { GHGProtocolIcon };
